export let appRoutes = {
  "/dashboard/home": "Home", //Header Name
  "/dashboard/history": "User History", //Header Name
};

export const headerOptionsRoutes = ["/dashboard/history"];

export const routesWithoutBackground = ["/dashboard/history", "/dashboard/home"];
